export default __webpack_public_path__ + "static/media/PAFI_Minutes Summary of GMS of June 2023.498d0950.pdf";